/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TaskPrivateBoardIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TaskPrivateBoardIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TaskPrivateBoardIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TaskPrivateBoardIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 14"
 style={{'--as-1-ZxpUHU': alignSelf,'--mt-2-ZxpUHU': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZxpUHU': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZxpUHU': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZxpUHU': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZxpUHU': opacity,'--w-10-ZxpUHU': typeof width === 'number' ? `${width}px` : width,'--h-11-ZxpUHU': typeof height === 'number' ? `${height}px` : height,'--f-12-ZxpUHU': fill,'--a-7-ZxpUHU': isAnimated ? animation : "none",'--sd-8-ZxpUHU': isAnimated ? strokeDashoffset : 0,'--sd-9-ZxpUHU': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TaskPrivateBoardIcon.SvgPath"
  data-view-path={viewPath}
 d="M2 1.5a2.25 2.25 0 002.25 2.25h3A2.25 2.25 0 009.5 1.5V1h.5a1.5 1.5 0 011.5 1.5v10A1.5 1.5 0 0110 14H1.5A1.5 1.5 0 010 12.5v-10A1.5 1.5 0 011.5 1H2v.5zm3.762 3.8a2.485 2.485 0 00-2.485 2.484v.48a.904.904 0 00-.677.875v2.258c0 .498.404.903.903.903H8.02a.904.904 0 00.903-.904V9.14a.904.904 0 00-.678-.875v-.48A2.484 2.484 0 005.762 5.3zm0 1.355a1.13 1.13 0 011.129 1.13v.45H4.63v-.45a1.13 1.13 0 011.13-1.13zM7.25 0a1 1 0 011 1v.5a1 1 0 01-1 1h-3a1 1 0 01-1-1V1a1 1 0 011-1h3z"
 style={{'--f-12-ZxpUHU': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}